import { createSlice } from '@reduxjs/toolkit'

export const itemSlice = createSlice({
  name: 'item',
  initialState: {
    value: {type: "hotel",
     names:['נתיב מאיר - הפסגה 7'],
      data: [],
      idxs:[]},
  },
  reducers: {
    setItem: (state, action) => {
    
      state.value =action.payload
    },
   
  },
})

// Action creators are generated for each case reducer function
export const { setItem } = itemSlice.actions

export default itemSlice.reducer